import ShippingsMixin from '@/mixins/shippings.mixin.js'

export default {
  data() {
    return {
      dataTransformersSetup: {
        Shippings: {
          transform: (shipping) => {
            return this.setItemsToShow(shipping)
          },
          transformAll: (shippings) => {
            return shippings.map(x => { return this.dataTransformers.shippings.transform(x) })
          }
        }
      }
    }
  },
  mixins: [ShippingsMixin]
}
